import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import get from 'lodash.get'
import Loader from '../../../../Shared/Loader'
import { getCountries } from '../../../../../api'
import sortBy from 'lodash.sortby'
import InputTracked from '../../../../Shared/FormTracked/InputTracked'
import SelectTracked from '../../../../Shared/FormTracked/SelectTracked'
import TextAreaTracked from '../../../../Shared/FormTracked/TextAreaTracked'
import { trackingEvent } from '../../../../../constants'
import { factsheetActions } from '../../../../../redux/actions/factsheet'
import { connect } from 'react-redux'
import PricingResetConfirmationOverlay from '../../../../Shared/Factsheet/PricingResetConfirmationOverlay'
import { FACT_IDS } from '../../../../Shared/Factsheet/constants'
import './styles.scss'

// Todo: feels like this is way to complicated written?
class EditBasic extends PureComponent {
  state = {
    initialized: false,
    loading: false,
    countries: [],
    statesMap: {},
    error: null,
    form: {},
    isFormValid: null,
    showCountryChangeConfirmation: false,
    countryCodeToBeChangedTo: null,
    countryNameToBeChangedTo: null,
  }
  abortController = new AbortController()

  requiredFields = {
    name: 1,
    address: 1,
    city: 1,
    countryCode: 1,
    zip: 1,
  }

  componentDidMount () {
    this.init()
  }

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  init () {
    this.setState({ loading: true, error: null }, async () => {
      if (this.abortController !== null) {
        this.abortController.abort()
      }
      this.abortController = new AbortController()
      const requests = []
      let request = getCountries(this.abortController)
      requests.push(request.fetchPromise)
      try {
        const responses = await Promise.all(requests)
        const countries = responses[0]
        let countryOptions = countries.map((country) => {
          return { label: country.name, value: country.code }
        })
        countryOptions = sortBy(countryOptions, ['label'])

        // Find all states
        let states = []
        for (let i = 0; i < countries.length; i++) {
          if (countries[i].hasOwnProperty('states')) {
            for (let j = 0; j < countries[i].states.length; j++) {
              states.push(countries[i].states[j])
            }
          }
        }
        // Populate statesMap
        const statesMap = {}
        for (let i = 0; i < states.length; i++) {
          if (!statesMap.hasOwnProperty(states[i].countryCode)) {
            statesMap[states[i].countryCode] = []
          }
          statesMap[states[i].countryCode].push(states[i])
        }
        this.setState({ countries: countryOptions, statesMap: statesMap, loading: false, initialized: true })
      } catch (e) {
        this.setState({ loading: false, error: true })
      }
    })
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps !== this.props || prevState.statesMap !== this.state.statesMap) {
      this.populateFormFromProps()
    }
  }

  isRequiredField (key, newForm = null) {
    if (this.requiredFields.hasOwnProperty(key)) {
      return true
    }
    const form = newForm === null ? this.state.form : newForm
    if (key === 'stateId') {
      if (!form.hasOwnProperty('countryCode')) {
        return false
      }
      if (!this.state.statesMap.hasOwnProperty(form.countryCode.value)) {
        return false
      }
      return this.state.statesMap[form.countryCode.value].length > 0
    }
    return false
  }

  populateFormFromProps () {
    const latitude = get(this.props.giataHotelierProperty, 'latitude', '')
    const longitude = get(this.props.giataHotelierProperty, 'longitude', '')
    const zip = get(this.props.giataHotelierProperty, 'zip', '')
    const stateId = get(this.props.giataHotelierProperty, 'state.id', null)
    const countryCode = get(this.props.giataHotelierProperty, 'country.code', '')
    const city = get(this.props.giataHotelierProperty, 'city', '')
    const address = get(this.props.giataHotelierProperty, 'address', '')
    let name = get(this.props.giataHotelierProperty, 'name', '')
    const translatedName = get(this.props.giataHotelierProperty, 'translations.name.en_GB', null)
    if (translatedName !== null) {
      name = translatedName
    }
    const form = {
      latitude: { value: latitude },
      longitude: { value: longitude },
      zip: { value: zip },
      stateId: { value: stateId },
      countryCode: { value: countryCode },
      city: { value: city },
      address: { value: address },
      name: { value: name }
    }

    let isFormValid = true
    // Validate each key
    Object.keys(form).forEach((formKey) => {
      let isRequired = this.isRequiredField(formKey, form)
      form[formKey].isRequired = isRequired

      // only do validation if
      // formKey has no isValid property yet, or value is different, or isRequired changed (stateId)
      if (
        !this.state.form.hasOwnProperty(formKey) ||
        form[formKey].value !== this.state.form[formKey].value ||
        !this.state.form[formKey].hasOwnProperty('isValid') ||
        isRequired !== this.state.form[formKey].isRequired
      ) {
        form[formKey].isValid = this.validateFormValue(formKey, form[formKey].value, isRequired)
      } else {
        form[formKey].isValid = this.state.form[formKey].isValid
      }
      if (form[formKey].isValid === false) {
        isFormValid = false
      }
    })
    const previousIsFormValid = this.state.isFormValid
    this.setState({ form, isFormValid }, () => {
      if (isFormValid !== previousIsFormValid) {
        this.props.onValidationChange(isFormValid)
      }
    })
  }

  validateFormValue (key, value, isRequired) {
    if (isRequired && (value === null || value.toString().trim() === '')) {
      return false
    }
    return true
  }

  onNameChange = (e) => {
    const value = e.target.value

    const newProperty = { ...this.props.giataHotelierProperty }
    if (!newProperty.hasOwnProperty('translations') || newProperty.translations === null) {
      newProperty.translations = {}
    }
    if (!newProperty.translations.hasOwnProperty('name')) {
      newProperty.translations.name = {}
    }
    newProperty.translations = { ...newProperty.translations }
    newProperty.translations.name = { ...newProperty.translations.name }
    newProperty.translations.name.en_GB = value
    this.props.onPropertyChange(newProperty)
  }

  onChange = (e) => {
    const newProperty = { ...this.props.giataHotelierProperty }
    newProperty[e.target.name] = e.target.value
    this.props.onPropertyChange(newProperty)
  }

  processCountryChange = (countryCode) => {
    const newProperty = { ...this.props.giataHotelierProperty }
    if (!newProperty.hasOwnProperty('country') || newProperty.country === null) {
      newProperty.country = {}
    }
    newProperty.country = { ...newProperty.country }
    newProperty.country.code = countryCode
    delete newProperty.state
    this.props.onPropertyChange(newProperty)
    this.props.putCountryCodeFact(countryCode)
  }

  onCountryChange = (e) => {
    const value = e.target.value
    if (!this.props.factsheetFacts[FACT_IDS.CURRENCY]) {
      this.processCountryChange(value)
      return
    }
    const country = this.state.countries.find(country => country.value === value)
    this.setState({
      showCountryChangeConfirmation: true,
      countryCodeToBeChangedTo: value,
      countryNameToBeChangedTo: country.label,
    })
  }

  onConfirmCountryChange = () => {
    this.setState({
      showCountryChangeConfirmation: false,
    })
    this.state.countryCodeToBeChangedTo && this.processCountryChange(this.state.countryCodeToBeChangedTo)
  }

  onCancelCountryChange = () => {
    this.setState({
      showCountryChangeConfirmation: false,
      countryCodeToBeChangedTo: null,
    })
  }

  onStateChange = (e) => {
    const value = e.target.value
    let state = null
    const countryCode = get(this.props.giataHotelierProperty, 'country.code', '')
    if (countryCode !== null && this.state.statesMap.hasOwnProperty(countryCode)) {
      for (let i = 0; i < this.state.statesMap[countryCode].length; i++) {
        if (this.state.statesMap[countryCode][i].id.toString() === value) {
          state = this.state.statesMap[countryCode][i]
        }
      }
    }
    const newProperty = { ...this.props.giataHotelierProperty }
    newProperty.state = null
    if (state !== null) {
      newProperty.state = {
        code: state.code,
        countryCode: state.countryCode,
        id: state.id,
        name: state.name
      }
    }
    this.props.onPropertyChange(newProperty)
  }

  getLatLngValueFiltered (v) {
    if (typeof v === 'number') {
      return v
    }
    if (typeof v !== 'string') {
      return null
    }
    const floatValue = parseFloat(v.replace(',', '.'))
    if (isNaN(floatValue)) {
      return null
    }
    return floatValue
  }

  onLatitudeBlur = () => {
    const v = this.getLatLngValueFiltered(this.state.form.latitude.value)
    const newProperty = { ...this.props.giataHotelierProperty }
    if (v === null) {
      if (newProperty.hasOwnProperty('latitude')) {
        delete newProperty.latitude
      }
    } else {
      newProperty.latitude = v
    }
    this.props.onPropertyChange(newProperty)
  }
  onLongitudeBlur = () => {
    const v = this.getLatLngValueFiltered(this.state.form.longitude.value)
    const newProperty = { ...this.props.giataHotelierProperty }
    if (v === null) {
      if (newProperty.hasOwnProperty('longitude')) {
        delete newProperty.longitude
      }
    } else {
      newProperty.longitude = v
    }
    this.props.onPropertyChange(newProperty)
  }
  onLatitudeChange = (e) => {
    this.setState(state => ({
      form: { ...state.form, latitude: { ...state.form.latitude, value: e.target.value } }
    }))
  }

  onLongitudeChange = (e) => {
    this.setState(state => ({
      form: { ...state.form, longitude: { ...state.form.longitude, value: e.target.value } }
    }))
  }

  render () {
    const { t } = this.props
    const eventName = trackingEvent.editPropertyInfoField
    let content
    if (this.state.initialized && Object.keys(this.state.form).length > 0) {
      let states = []
      if (this.state.form.countryCode.value !== '' && this.state.statesMap.hasOwnProperty(this.state.form.countryCode.value)) {
        states = this.state.statesMap[this.state.form.countryCode.value].map((state) => {
          return { label: state.name, value: state.id }
        })
      }
      content = <div className="edit-property-basic">
        {this.state.showCountryChangeConfirmation && <PricingResetConfirmationOverlay
          onConfirm={this.onConfirmCountryChange}
          onCancel={this.onCancelCountryChange}
          countryName={this.state.countryNameToBeChangedTo}
        />}
        <div className="edit-property-basic__heading">
          <h3 className="edit-property-heading">Property</h3>
        </div>
        <div className="edit-property-basic__one_col_editable">
          <div>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Name' }}
              label={t('NAME')} onChange={this.onNameChange}
              value={this.state.form.name.value} required={
              this.state.form.name.isRequired
            } valid={this.state.form.name.isValid}/>
          </div>
        </div>
        <div className="edit-property-basic__one_col_editable">
          <div>
            <TextAreaTracked
              eventName={eventName}
              eventOpts={{ field: 'Address' }}
              label={t('ADDRESS')}
              name={'address'}
              onChange={this.onChange}
              value={this.state.form.address.value} valid={this.state.form.address.isValid}
              required={this.state.form.address.isRequired}
              height={'122px'}
            />
          </div>
        </div>
        <div className="edit-property-basic__two_col_editable">
          <div>
            <SelectTracked
              eventName={eventName}
              eventOpts={{ field: 'Country' }}
              label={t('COUNTRY')}
              onChange={this.onCountryChange}
              valid={this.state.form.countryCode.isValid}
              options={this.state.countries} selected={this.state.form.countryCode.value}
              required={this.state.form.countryCode.isRequired}/>
          </div>
          <div>
            <SelectTracked
              eventName={eventName}
              eventOpts={{ field: 'State' }}
              label={t('STATE')} onChange={this.onStateChange} options={states}
              selected={this.state.form.stateId.value}
              valid={this.state.form.stateId.isValid}
              disabled={states.length === 0} required={this.state.form.stateId.isRequired}/>
          </div>
        </div>
        <div className="edit-property-basic__two_col_editable">
          <div>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'City' }}
              label={t('CITY')}
              name={'city'}
              onChange={this.onChange}
              valid={this.state.form.city.isValid}
              value={this.state.form.city.value} required={this.state.form.city.isRequired}/>

          </div>
          <div>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Zip' }}
              label={t('ZIP')}
              name={'zip'}
              onChange={this.onChange}
              valid={this.state.form.zip.isValid}
              value={this.state.form.zip.value} required={this.state.form.zip.isRequired}/>
          </div>
        </div>
        <div className="edit-property-basic__two_col_editable">
          <div>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Latitude' }}
              label={t('LATITUDE')} onBlur={this.onLatitudeBlur}
              onChange={this.onLatitudeChange}
              valid={this.state.form.latitude.isValid}
              required={this.state.form.latitude.isRequired}
              value={this.state.form.latitude.value}/>

          </div>
          <div>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Longitude' }}
              label={t('LONGITUDE')}
              onBlur={this.onLongitudeBlur}
              onChange={this.onLongitudeChange}
              valid={this.state.form.longitude.isValid}
              required={this.state.form.longitude.isRequired}
              value={this.state.form.longitude.value}/>
          </div>
        </div>
      </div>
    }
    return (
      <div>
        {this.state.loading && <Loader size={32}/>}
        {content}
      </div>
    )
  }
}

EditBasic.propTypes = {
  giataHotelierProperty: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onValidationChange: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    factsheetFacts: state.factsheet.facts,
  }
}

const mapDispatchToProps = {
  putCountryCodeFact: factsheetActions.putCountryCodeFact,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EditBasic))
